/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.5.1
 */
import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client/index.js';
import { c as connectInteractive, u as updateHostInteraction, d as disconnectInteractive } from './interactive.js';

const tileSelectGroupCss = ":host([disabled]){cursor:default;-webkit-user-select:none;user-select:none;opacity:var(--calcite-ui-opacity-disabled)}:host([disabled]) *,:host([disabled]) ::slotted(*){pointer-events:none}:host{display:flex;flex-wrap:wrap}:host ::slotted(calcite-tile-select){margin-block-end:1px;margin-inline-end:1px}:host([layout=vertical]){flex-direction:column}:host([disabled]) ::slotted([calcite-hydrated][disabled]),:host([disabled]) [calcite-hydrated][disabled]{opacity:1}:host([hidden]){display:none}[hidden]{display:none}";

const TileSelectGroup = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.disabled = false;
    this.layout = "horizontal";
  }
  //--------------------------------------------------------------------------
  //
  //  Lifecycle
  //
  //--------------------------------------------------------------------------
  connectedCallback() {
    connectInteractive(this);
  }
  componentDidRender() {
    updateHostInteraction(this);
  }
  disconnectedCallback() {
    disconnectInteractive(this);
  }
  render() {
    return h("slot", null);
  }
  get el() { return this; }
  static get style() { return tileSelectGroupCss; }
}, [1, "calcite-tile-select-group", {
    "disabled": [516],
    "layout": [513]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["calcite-tile-select-group"];
  components.forEach(tagName => { switch (tagName) {
    case "calcite-tile-select-group":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, TileSelectGroup);
      }
      break;
  } });
}
defineCustomElement$1();

const CalciteTileSelectGroup = TileSelectGroup;
const defineCustomElement = defineCustomElement$1;

export { CalciteTileSelectGroup, defineCustomElement };
